/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressClient,
    AddressClientFromJSON,
    AddressClientFromJSONTyped,
    AddressClientToJSON,
    UserTokenUserNestedExternalSystem,
    UserTokenUserNestedExternalSystemFromJSON,
    UserTokenUserNestedExternalSystemFromJSONTyped,
    UserTokenUserNestedExternalSystemToJSON,
    UserTokenUserNestedUserGroup,
    UserTokenUserNestedUserGroupFromJSON,
    UserTokenUserNestedUserGroupFromJSONTyped,
    UserTokenUserNestedUserGroupToJSON,
    UserTokenUserNestedUserRoles,
    UserTokenUserNestedUserRolesFromJSON,
    UserTokenUserNestedUserRolesFromJSONTyped,
    UserTokenUserNestedUserRolesToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserTokenUserNested
 */
export interface UserTokenUserNested {
    /**
     * 
     * @type {number}
     * @memberof UserTokenUserNested
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTokenUserNested
     */
    clientId?: number;
    /**
     * 
     * @type {Date}
     * @memberof UserTokenUserNested
     */
    lastLogin?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNested
     */
    ssoId?: string | null;
    /**
     * 
     * @type {object}
     * @memberof UserTokenUserNested
     */
    loginCredentials?: object | null;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNested
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNested
     */
    surname: string;
    /**
     * 
     * @type {object}
     * @memberof UserTokenUserNested
     */
    contact?: object | null;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNested
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserTokenUserNested
     */
    deleted: number;
    /**
     * 
     * @type {number}
     * @memberof UserTokenUserNested
     */
    active: number;
    /**
     * 
     * @type {number}
     * @memberof UserTokenUserNested
     */
    averageSpeed: number;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNested
     */
    languageIso6391?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNested
     */
    password?: string | null;
    /**
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     * @type {boolean}
     * @memberof UserTokenUserNested
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserTokenUserNested
     */
    isContactPerson?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNested
     */
    binaryRights?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNested
     */
    externalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNested
     */
    binaryRightsBackup?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTokenUserNested
     */
    isSsoAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserTokenUserNested
     */
    binaryRightsDirty?: boolean;
    /**
     * 
     * @type {AddressClient}
     * @memberof UserTokenUserNested
     */
    client?: AddressClient;
    /**
     * 
     * @type {UserTokenUserNestedExternalSystem}
     * @memberof UserTokenUserNested
     */
    externalSystem?: UserTokenUserNestedExternalSystem;
    /**
     * 
     * @type {Array<UserTokenUserNestedUserGroup>}
     * @memberof UserTokenUserNested
     */
    readonly userGroup?: Array<UserTokenUserNestedUserGroup>;
    /**
     * 
     * @type {Array<UserTokenUserNestedUserRoles>}
     * @memberof UserTokenUserNested
     */
    readonly userRoles?: Array<UserTokenUserNestedUserRoles>;
}

export function UserTokenUserNestedFromJSON(json: any): UserTokenUserNested {
    return UserTokenUserNestedFromJSONTyped(json, false);
}

export function UserTokenUserNestedFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTokenUserNested {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'clientId': !exists(json, 'client_id') ? undefined : json['client_id'],
        'lastLogin': !exists(json, 'last_login') ? undefined : (json['last_login'] === null ? null : new Date(json['last_login'])),
        'ssoId': !exists(json, 'sso_id') ? undefined : json['sso_id'],
        'loginCredentials': !exists(json, 'login_credentials') ? undefined : json['login_credentials'],
        'name': json['name'],
        'surname': json['surname'],
        'contact': !exists(json, 'contact') ? undefined : json['contact'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'deleted': json['deleted'],
        'active': json['active'],
        'averageSpeed': json['average_speed'],
        'languageIso6391': !exists(json, 'language_iso_639_1') ? undefined : json['language_iso_639_1'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'isActive': !exists(json, 'is_active') ? undefined : json['is_active'],
        'isContactPerson': !exists(json, 'is_contact_person') ? undefined : json['is_contact_person'],
        'binaryRights': !exists(json, 'binary_rights') ? undefined : json['binary_rights'],
        'externalId': !exists(json, 'external_id') ? undefined : json['external_id'],
        'binaryRightsBackup': !exists(json, 'binary_rights_backup') ? undefined : json['binary_rights_backup'],
        'isSsoAdmin': !exists(json, 'is_sso_admin') ? undefined : json['is_sso_admin'],
        'binaryRightsDirty': !exists(json, 'binary_rights_dirty') ? undefined : json['binary_rights_dirty'],
        'client': !exists(json, 'client') ? undefined : AddressClientFromJSON(json['client']),
        'externalSystem': !exists(json, 'external_system') ? undefined : UserTokenUserNestedExternalSystemFromJSON(json['external_system']),
        'userGroup': !exists(json, 'user_group') ? undefined : ((json['user_group'] as Array<any>).map(UserTokenUserNestedUserGroupFromJSON)),
        'userRoles': !exists(json, 'user_roles') ? undefined : ((json['user_roles'] as Array<any>).map(UserTokenUserNestedUserRolesFromJSON)),
    };
}

export function UserTokenUserNestedToJSON(value?: UserTokenUserNested | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.clientId,
        'last_login': value.lastLogin === undefined ? undefined : (value.lastLogin === null ? null : value.lastLogin.toISOString()),
        'sso_id': value.ssoId,
        'login_credentials': value.loginCredentials,
        'name': value.name,
        'surname': value.surname,
        'contact': value.contact,
        'note': value.note,
        'deleted': value.deleted,
        'active': value.active,
        'average_speed': value.averageSpeed,
        'language_iso_639_1': value.languageIso6391,
        'password': value.password,
        'is_active': value.isActive,
        'is_contact_person': value.isContactPerson,
        'binary_rights': value.binaryRights,
        'external_id': value.externalId,
        'binary_rights_backup': value.binaryRightsBackup,
        'is_sso_admin': value.isSsoAdmin,
        'binary_rights_dirty': value.binaryRightsDirty,
        'client': AddressClientToJSON(value.client),
        'external_system': UserTokenUserNestedExternalSystemToJSON(value.externalSystem),
    };
}


